import { render, staticRenderFns } from "./lotteryDetail.vue?vue&type=template&id=5f71de96&scoped=true"
import script from "./lotteryDetail.vue?vue&type=script&lang=js"
export * from "./lotteryDetail.vue?vue&type=script&lang=js"
import style0 from "./lotteryDetail.vue?vue&type=style&index=0&id=5f71de96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f71de96",
  null
  
)

export default component.exports